export default __webpack_public_path__ + "static/media/neural_art.7c3acc7b.jpeg";